<script setup lang="ts">
defineProps<{
  label: string;
  value: number;
  color?: string;
}>();
</script>

<template>
  <div
    class="rounded-xl w-28 h-28 p-4 flex flex-col items-center"
    :style="{backgroundColor: color || '#f0f0f0' }"
  >
    <div class="flex flex-1 text-sm text-center items-center">
      {{ label }}
    </div>
    <div class="flex text-3xl font-bold justify-center items-center px-2">
      {{ value }}
    </div>
  </div>
</template>

<style scoped>

</style>
